import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  standalone: true,
  imports: [MatIconModule, CommonModule, FormsModule],
  selector: 'app-chatBot',
  templateUrl: './chatBot.component.html',
  styleUrls: ['./chatBot.component.css']
})
export class ChatbotComponent {
  @ViewChild('chatMessages') chatMessages!: ElementRef;
  constructor(private router: Router) { }

  messages: { text: string, fromUser: boolean }[] = [];
  userMessage: string = '';
  isOpen: boolean = false;

  toggleChat() {
    // this.isOpen = !this.isOpen;
    this.router.navigate(['/landing-page']);
  }

  sendMessage() {
    if (this.userMessage.trim() === '') return;

    // Add user message
    this.messages.push({ text: this.userMessage, fromUser: true });

    // Simulate bot response
    setTimeout(() => {
      this.messages.push({ text: 'Hello! How can I assist you?', fromUser: false });
      this.scrollToBottom();
    }, 1000);

    this.userMessage = '';
    this.scrollToBottom();
  }
  scrollToBottom() {
    setTimeout(() => {
      if (this.chatMessages) {
        this.chatMessages.nativeElement.scrollTop = this.chatMessages.nativeElement.scrollHeight;
      }
    }, 100);
  }
}
